import React from "react";
import MIcon from "../../icons/MIcon";

const StatCard = ({ icon, label, value, delta }) => {
  const positive = typeof delta === "number" && delta >= 0;
  return (
    <div className="flat-card rounded-xl p-5 animate-float-in">
      <div className="flex items-start justify-between gap-3 mb-3">
        <div className="w-9 h-9 rounded-lg bg-brand/10 dark:bg-brand/15 flex items-center justify-center text-brand dark:text-brand shrink-0">
          <MIcon name={icon} className="sm" />
        </div>
        {/* {typeof delta === "number" && (
          <span
            className={`text-[11px] font-medium px-1.5 py-0.5 rounded ${
              positive
                ? "bg-emerald-500/10 dark:bg-emerald-400/10 text-emerald-600 dark:text-emerald-400"
                : "bg-red-500/10 dark:bg-red-400/10 text-red-600 dark:text-red-400"
            }`}
          >
            {positive ? "+" : ""}
            {delta.toFixed(1)}%
          </span>
        )}*/}
      </div>
      <p className="text-xs text-on-surface-light-variant dark:text-on-surface-variant uppercase tracking-wider mb-1">
        {label}
      </p>
      <p className="font-display text-2xl font-semibold text-on-surface-light dark:text-on-surface">
        {value}
      </p>
    </div>
  );
};

export default StatCard;
